import axios from "axios";
import { apiKey } from "../config";

export default function httpSetup () {
    axios.defaults.headers.common['app-security-key'] = apiKey;
}